import { render, staticRenderFns } from "./BoardingPassPage.vue?vue&type=template&id=559dcb1a&"
import script from "./BoardingPassPage.vue?vue&type=script&lang=js&"
export * from "./BoardingPassPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports